import set from "@rill/set";
import _ from "lodash";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import ListView from "./progress-photos/components/ListView";
import PreviewPhotoModal from "./progress-photos/components/PreviewPhotoModal";
import TimeLineView from "./progress-photos/components/TimeLineView";
import ProgressPhotos from "./progress-photos/ProgressPhotos";
import { isAdminOrOwner } from "../../../utils/organization-permissions-helpers";

const ProgressPhotosController = (app) => {
  app.get(
    "/progress-photos",
    set("heading", "Progress Photos"),
    async ({ locals, res, req, load }) => {
      const { query } = req;
      const { view } = query;
      const { bodycomp, showBack } = query;

      let comesFromBodyComp = false;

      const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
        locals.organizationRoleName
      );

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }

      if (query.threadId) {
        await load("comments", {
          threadId: query.threadId,
        });
      }

      // Required conditional because this could be undefined when refreshing
      if (Boolean(bodycomp) && req?.original?.headers?.referer) {
        comesFromBodyComp =
          req.original.headers.referer.includes("body-composition") ||
          req.original.headers.referer.includes("check-in-summary");
      }
      if (showBack) comesFromBodyComp = true;
      const views = {
        List: (
          <ListView locals={locals} comesFromBodyComp={comesFromBodyComp} />
        ),
        Timeline: (
          <TimeLineView locals={locals} comesFromBodyComp={comesFromBodyComp} />
        ),
      };
      const modal = _.get(query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
        "preview-photo": (
          <PreviewPhotoModal
            dailyStatId={query.dailyStatId}
            photo={{
              type: query.photoType,
              pictureImg: query.pictureImg,
            }}
            threadId={query.threadId}
            locals={locals}
            utcDate={query.utcDate}
          />
        ),
      }[modal.type];
      res.body = (
        <ProgressPhotos locals={locals}>
          {views[view] ? views[view] : views.List}
        </ProgressPhotos>
      );
    }
  );
};

export default ProgressPhotosController;
